import React, { useEffect, useState } from 'react';

import { auth } from './config';
import AuthContext from './AuthContext';
import { db } from './FireDataContext';
import { Dbx } from '../dbx';
import { onLocalHost } from '../../app/common/useful';
// import Sentinel from '../monitoring/sentinel';
import { timestamp } from '../../app/data/validate';

const signup = ({ email, password }) => {
    return auth.createUserWithEmailAndPassword(email.trim(), password.trim());
}

const logout = () => {
    sessionStorage?.clear();
    return auth.signOut();
}

const verify = () => {
    return auth.currentUser.sendEmailVerification();
}

const reload = () => {
    return auth.currentUser.reload();
}

const login = ({ email, password }) => {
    return new Promise((resolve, reject) => {
        try {
            sessionStorage?.clear();
            resolve(auth.signInWithEmailAndPassword(email.trim(), password.trim()));
        }
        catch (error) {
            reject(error);
        }
    })
}

const reset = email => auth.sendPasswordResetEmail(email);

const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState();
    const [waiting, setWaiting] = useState(true);

    const value = {
        currentUser,
        signup,
        login,
        logout,
        reset,
        verify,
        reload
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {

            const identity = user && await db.get({
                path: `users/${user.uid}`,
                context: 'AuthProvider'
            });

            // if (identity?.useLogRocket) {
            //     Sentinel.startTracking(false);
            //     Sentinel.identifyUser(identity);
            // }
            // else {
            //     console.log('LogRocket disabled');
            // }

            if (identity) {
                const userData = { ...user, organizationId: identity.organization, roles: identity.roles, name: identity.name, verified: user.emailVerified, xeroContactId: identity.xeroContactId };
                if (onLocalHost()) {
                    const uid = localStorage.getItem('2e6a2b671bf7');
                    if (uid) {
                        userData.uid = uid;
                    }
                    setCurrentUser(userData);
                }
                else {
                    setCurrentUser(userData);
                }
            }
            else {
                setCurrentUser(user);
            }

            setWaiting(false);

            if (user) {
                // keep the user's email up to date and easily accessible!
                db.update({
                    path: `users/${user.uid}`,
                    payload: {
                        email: user.email,
                        ts: timestamp(),
                        verified: user.emailVerified
                    },
                    context: 'AuthProvider'
                })
                    .catch(error => console.log(`AuthProvider error updating users/${user.uid}`, error));

                // do we need to do this for members!?
                db.subscribe({
                    path: 'intermediaries', hook: intermediaries => {
                        Dbx.publish({
                            topic: 'intermediaries',
                            value: intermediaries,
                            durable: true
                        })
                    },
                    context: 'AuthProvider'
                });

                db.subscribe({
                    path: 'vulnerability_categories', hook: categories => {
                        // console.log('categories', categories);
                        Dbx.publish({
                            topic: 'vulnerability_categories',
                            value: categories,
                            durable: true
                        });

                        categories.forEach(cat => {
                            db.subscribe({
                                path: `vulnerability_categories/${cat.id}/vulnerabilities`,
                                hook: vulnerabilities => {
                                    Dbx.publish({
                                        topic: cat.id,
                                        value: vulnerabilities,
                                        durable: true
                                    });
                                },
                                context: 'AuthProvider'
                            })
                        })
                    },
                    context: 'AuthProvider'
                });

                db.subscribe({
                    path: 'intermediary_services', hook: services => {
                        Dbx.publish({
                            topic: 'intermediary_services',
                            value: services,
                            durable: true
                        });
                    },
                    context: 'AuthProvider'
                });

                // db.subscribe({
                //     path: 'fubar', hook: doc => {
                //         console.log('fubar', doc);
                //     },
                //     context: 'AuthProvider'
                // });

                // Sentinel.identifyUser({
                //     uid: user.uid,
                //     email: user.email,
                //     name: identity?.name ?? user.email
                // })

                if (identity) {
                    Dbx.publish({
                        topic: 'user',
                        value: { ...identity, uid: user.uid },
                        durable: true
                    });

                    db.subscribe({
                        path: `organizations/${identity.organization}`,
                        hook: organization => {
                            Dbx.publish({
                                topic: 'organization',
                                value: organization,
                                durable: true
                            });
                        },
                        context: 'AuthProvider'
                    });
                }
            }
            else {
                sessionStorage?.clear();
            }
        });

        return unsubscribe;

    }, [])

    return (
        <AuthContext.Provider value={{ ...value }}>
            {!waiting && children}
        </AuthContext.Provider>
    )
}

export { AuthProvider }

